import { FlaskIcon, P, rem, Spacer, theme } from 'design-system';

import { Section, SectionInner } from '../components/section';

export const TestModeBanner = () => {
  return (
    <Section
      css={{
        backgroundColor: theme.colors.yellow3,
      }}
    >
      <Spacer height={24} />
      <SectionInner
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <P
          size="medium"
          css={{
            color: theme.colors.yellow11,
            fontWeight: theme.fontWeights.medium,
            display: 'flex',
            gap: rem(12),
            alignItems: 'center',
          }}
        >
          <FlaskIcon width={rem(16)} />
          This Preflight instance is in test mode. Live payments are disabled.
        </P>
      </SectionInner>
      <Spacer height={24} />
    </Section>
  );
};
